import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const DisclosureRegardingBackgroundInvestigation = forwardRef(({ data, company, refToPrint }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                },
            }
        },
    }))

    return (
        <div ref={refToPrint} className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-gray-800">
                        FCRA - DISCLOSURE REGARDING BACKGROUND INVESTIGATION
                    </h1>
                    <p className="text-base text-gray-700">
                        <span className="font-semibold">{company?.name}</span>, the "Company," may obtain information about you from
                        a third-party consumer reporting agency for employment purposes. Thus, you may be the subject of a "consumer report"
                        which may include information about your character, general reputation, personal characteristics, and/or mode of living.
                        These reports may contain information regarding your criminal history, social security verification,
                        motor vehicle records ("driving records"), verification of your education or employment history (including income),
                        or other background checks.
                    </p>
                    <div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-700 space-y-2 border border-gray-200">
                        <p>
                            You have the right, upon written request made within a reasonable time, to request whether a consumer report has been run
                            about you and to request a copy of your report.
                        </p>
                        <p>
                            These searches will be conducted by VerifiedID.
                            <br />
                            Address: 11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA
                            <br />
                            Phone: <a href="tel:+18887182597" className="text-blue-600 underline">(888) 718-2597</a>
                            <br />
                            Website: <a href="https://verifiedid.co" className="text-blue-600 underline" target="_blank">https://verifiedid.co</a>
                        </p>
                    </div>
                    <p className="text-base text-gray-700">
                        To the extent permitted by law, the Company may obtain consumer reports from any outside organization throughout
                        the course of your employment.
                    </p>
                    <p className="text-base text-gray-700">
                        [End of FCRA - DISCLOSURE REGARDING BACKGROUND INVESTIGATION]
                    </p>
                </div>
            </div>
        </div>
    )

})

export default DisclosureRegardingBackgroundInvestigation
